import { useNavigate, useLocation } from 'react-router';
import Paths from '@/configs/router/paths';

export const useChatNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lastNavRef = useRef<{ path: string; time: number }>({ path: '', time: 0 });
  return useCallback(
    (chat_id: string) => {
      const targetPath = `${Paths.MESSAGES_CHATS}/${chat_id}`;
      const currentPath = location.pathname;
      if (currentPath === targetPath) return;
      const now = Date.now();
      if (lastNavRef.current.path === targetPath && now - lastNavRef.current.time < 500) {
        return;
      }
      lastNavRef.current = { path: targetPath, time: now };
      navigate(targetPath);
    },
    [navigate, location.pathname]
  );
};
